module.exports = __webpack_public_path__ + "media/promotions/back-to-school_@2x-69adf5f5.png";